import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import API from "../services/api";
import "./ProductDetails.css";

export default function ProductDetails({ setCartCount }) {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  const navigate = useNavigate()


  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState("")
  const [comment, setComment] = useState("")
  const [canReview, setCanReview] = useState(false)
  const [alreadyReviewed, setAlreadyReviewed] = useState(false)
  const [features, setFeatures] = useState([])

  const handleToCart = async (productId) => {
    try {
      await API.post(`/api/cart?productId=${productId}&quantity=1`);
      const response = await API.get("/api/cart")
      setCartCount(response.data.length)
      alert("Added to cart")
    } catch (error) {
      console.log(error)
      alert("Failed to add to cart")
    }
  }

  useEffect(() => {
    if (id) {
      fetchFeatures(id);
    }
  }, [id])

  const fetchFeatures = async (productId) => {
    try {
      const res = await API.get(`/api/productFeatureValue/${productId}`)
      setFeatures(res.data)
    } catch (error) {
      console.log(error.res?.data)
    }
  }

  useEffect(() => {
    API.get(`/api/review/${id}`)
      .then(res => setReviews(res.data))
      .catch(error => console.log(error))
  }, [id])

  useEffect(() => {
    API.get(`/api/review/can-review/${id}`)
      .then(res => setCanReview(res.data))
      .catch(error => console.log(error))
  }, [id])

  useEffect(() => {
    API.get(`/api/review/already-reviewed/${id}`)
      .then(res => setAlreadyReviewed(res.data))
      .catch(error => console.log(error))
  }, [id])

  const submitReview = async () => {
    try {
      await API.post(`/api/review/${id}`, {
        rating: Number(rating),
        comment
      })

      setRating("")
      setComment("")

      const res = await API.get(`/api/review/${id}`);
      setReviews(res.data)

      setAlreadyReviewed(true)
      setCanReview(false)

      alert("Thank for your rating and review")
    } catch (error) {
      console.log(error)
      alert("Unable to do rating and review")
    }
  }

  const avgRating = reviews.length > 0 ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1) : null;

  const topFeatures = features.slice(0, 6)

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await API.get(`/api/products/${id}`);
        setProduct(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchProduct();
  }, [id]);


  const getFeatures = (name) => {
    return features.find(f => f.feature?.name === name)?.value
  }

  const handleBuyNow = async ( productId ) => {
    try {
      await API.post(`/api/cart?productId=${productId}&quantity=1`);

      const res = await API.get("/api/cart")
      setCartCount(res.data.length)
      navigate("/checkout")
    } catch (error) {
      console.log(error)
    }
  }

  if (!product) return <div className="loading">Loading...</div>;


  return (
    <div className="pd-page">
      <div className="pd-container">

        {/* LEFT - IMAGE */}
        <div className="pd-left">
          <div className="image-box">
            <img src={product.imageUrl} alt={product.name} />
          </div>
        </div>

        {/* RIGHT - DETAILS */}
        <div className="pd-right">

          <h1 className="title">
            {product.name}
            <span className="quick-specs" >
              ({getFeatures("RAM")} | {getFeatures("Storage")} | {getFeatures("Color")})
            </span>
          </h1>


          <div className="rating">
            {avgRating ? (
              <>⭐ {avgRating} ({reviews.length} reviews )</>
            ) : (
              <span className="text-muted">No ratings yet</span>
            )
            }
          </div>

          {/* PRICE */}
          <div className="price-box">
            <span className="price">₹{product.price}</span>
            <span className="old-price">₹{product.price + 4000}</span>
            <span className="discount">18% off</span>
          </div>

          {/* BUTTONS (NOW RIGHT SIDE ) */}
          <div className="action-buttons">
            <button className="add-cart" onClick={()=>handleToCart(product.id)}>🛒 Add to Cart</button>
            <button className="buy-now" onClick={()=> handleBuyNow(product.id)}>⚡ Buy Now</button>
          </div>

          {/* OFFERS */}
          <div className="offers">
            <p>💳 10% Instant Discount on Cards</p>
            <p>🚚 Free Delivery</p>
            <p>🔁 7 Days Replacement</p>
          </div>

          {/* HIGHLIGHTS */}
          <div className="section">
            <h3>Highlights</h3>
            <ul className="highlights">
              {topFeatures.map((f, i) => (
                <li key={i}>
                  {f.feature.name}: {f.value}
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      <div className="reviews-section">

        <h2>Ratings & Reviews</h2>

        {!avgRating && (
          <p className="text-muted">No ratings and reviews yet</p>
        )}

        {avgRating && (
          <div className="rating-summary">
            ⭐ {avgRating} / 5 ({reviews.length} reviews)
          </div>
        )}

        {canReview && !alreadyReviewed && (
          <div className="add-review">
            <h3>Write a Review</h3>

            <select value={rating} onChange={(e) => setRating(e.target.value)}>
              <option value="">Select Rating</option>
              {[1, 2, 3, 4, 5].map(r => (
                <option key={r} value={r}>{r} Star</option>
              ))}
            </select>

            <textarea
              placeholder="Write your review..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />

            <button onClick={submitReview}>Submit</button>
          </div>
        )}

        <div className="review-list">
          {reviews.map(r => (
            <div key={r.id} className="review-card">
              <div className="review-top">
                <span className="badge bg-success">⭐ {r.rating}</span>
                <span className="ms-2 fw-bold">{r.user?.name}</span>
              </div>
              <p className="mt-2">{r.comment}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}